<div mat-dialog-content>
  <h2 mat-dialog-title>
    {{ data.title | translate }}
  </h2>
  <pre class="formatted-data">{{ formattedData }}</pre>
</div>

<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ 'common.ok' | translate }}
  </button>
</div>
